import { Component, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { HttpResponse, HttpEventType, HttpHeaderResponse } from '@angular/common/http';
import { Router } from '@angular/router'
import { NewProjectViewService } from './new.project.view.service';
import { AppService } from '../../app.service';
import { ActivatedRoute } from '@angular/router'; 
import { Location } from '@angular/common';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { PersonViewService } from '../../PersonComponent/PersonViewComponent/person.view.service';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { Globals } from '../../globals';
import { ErrorModalComponent } from '../../shared/views/ErrorModalComponent/error.modal.component';
import translateJson from "../../../translate.json";
import customerJson from "../../../assets/config/customer.json";
import { ArchiveModalComponent } from '../../shared/views/ArchiveModalComponent/archive.modal.component';
import { ProjectTreeModalComponent } from './ProjectTreeModalComponent/project.tree.modal.component';
import { EntityTypes } from '../../shared/enum/EntityTypes';
import { AuthenticationService } from '../../auth';
import { formatDate } from '@angular/common';

enum viewType {SECURITYHANDLER, PROJECTSECURITYMANAGER};
enum otherTypeEnum {SUA, WORKFLOW};

@Component({
    selector: 'project-comp',
    providers: [AppService, NewProjectViewService, NgxSmartModalService, ConfirmService, PersonViewService, AuthenticationService], 
    templateUrl: './new.project.view.component.html',  
    styleUrls: ['../project.component.css']  
})

export class NewProjectViewComponent {   

    @ViewChild('errorModalComponent') errorModalComponent: ErrorModalComponent; 
    @ViewChild('archiveModal') archiveModal: ArchiveModalComponent;
    @ViewChild('projectTreeModal') projectTreeModal: ProjectTreeModalComponent;
    @ViewChild('pdfAttachmentViewer') pdfAttachmentViewer;

    // Get translation/text from customerJson
    private i18 = translateJson.i18;
    private projectHierarchyActive: boolean = customerJson.settings.projectHierarchyActive;
    private allowExportDigitalSuaXml: boolean = customerJson.settings.enableDigitalXmlSuaExport;
    edition: String = customerJson.edition;
    entityType = EntityTypes;

    selectedFiles: FileList;
    currentFileUpload: FileLikeObject;
    private customerOrgId: String = customerJson.customer.organisationId;
    isCustomer: boolean = false;
    public uploader: FileUploader = new FileUploader({allowedFileType: ["pdf"]});
    private attachmentContent: any;
    private showContentForAttachment: Boolean = false;
    private suaRks;

    private restoreSuaError = {
        header: this.i18.sua.form.archiveSuaRestoreErrorHeader,
        title: this.i18.sua.form.archiveSuaRestoreErrorTitle,
        message: this.i18.sua.form.archiveSuaRestoreErrorMessage
    }

    private otherType: String = otherTypeEnum[0];
    private sapoWorkflow: any = [];
    private newAttachment: Boolean = false;
    showAttBody: Boolean = false;
    private activeComponent: boolean;
    private project: any;
    showControlReasonVar: boolean = true;
    showProjectDetailsVar: boolean = true;
    showContactPersonDetails: boolean = true;
    id: String;
    ready: Boolean = false;
    showLoader: Boolean = false;
    private previousType: String;
    selectedView: any;
    rkReceiverActive: Boolean = customerJson.settings.RKReceiver;
    suaShowOperatorAndSupervisor: Boolean = customerJson.settings.suaShowOperatorAndSupervisor;
    suaShowBusinessManager = customerJson.settings.suaShowBusinessManager;
    parentProject: any = null;
    selectedSecClass = 1;
    showLocalOffices: boolean = customerJson.settings.showLocalOffices;
    showLocalOfficesForLevel: Number = customerJson.settings.showLocalOfficesForLevel;

    disableTextbox = false;
    numOfNotes:number = 0;

    pdfBlob: any = null;
    pdfName: string = null;
    currentPdfView: string = '';    

    private restoreProjectError = {
        header: this.i18.sua.form.archiveSuaRestoreErrorHeader,
        title: this.i18.sua.form.archiveSuaRestoreErrorTitle,
        message: ""
    }

    constructor(
        private router: Router,
        private service: NewProjectViewService,
        private activatedRoute: ActivatedRoute,
        private ngxSmartModalService: NgxSmartModalService,
        private personViewService: PersonViewService,
        private location: Location,
        private confirmService: ConfirmService,
        private sanitizer: DomSanitizer,
        private appService: AppService,
        private globals: Globals,
        private authService: AuthenticationService) {
            this.authService.isAuthenticated(); 
            this.activeComponent = appService.isComponentActive('project');
            this.id = this.activatedRoute.snapshot.paramMap.get('id');
            this.setDefault();
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        }

    /**
     * Initiate all fields
     */
    setDefault() {
        this.getProjectById(this.id);
        this.setInputWindow('SECURITYHANDLER');
        this.getAllRksForSua(this.id)
    }

/**
   * Set other type
   * @param type type of page
   */
      setOtherType(type:number) {
        this.otherType = otherTypeEnum[type];

        if (type == 1) {
            this.getSapoWorkflow();
        }
    }

    /**
     * This method will call for service in order to retrieve workflow by type
     * and then call setSapoWorkflow()
     */
    public getSapoWorkflow() { 
       this.service.getSapoWorkflow()
            .subscribe(
                data => this.setSapoWorkflow(data),
                error => console.log(error)                
            );      
    }

     /**
     * This method will set the RK workflow 
     */
     public setSapoWorkflow(workflow) {        
        this.sapoWorkflow = workflow;        
        var suaWorkflow = this.project.sapoWorkflowList;          
        for(let i=0; i < this.sapoWorkflow.length; i++) { 
            this.sapoWorkflow[i].active = false;
            this.sapoWorkflow[i].swDate = null;
            this.sapoWorkflow[i].translatedName = this.appService.getTranslateValueFromKeyStr(this.sapoWorkflow[i].i18, this.sapoWorkflow[i].readableName);

            for(let j=0; j < suaWorkflow.length; j++) {                
                if(suaWorkflow[j].swId == this.sapoWorkflow[i].id) {                    
                    this.sapoWorkflow[i].active = suaWorkflow[j].active;
                    this.sapoWorkflow[i].swDate = formatDate( suaWorkflow[j].swDate, 'yyyy-MM-dd', 'en') ;
                }
            }             
        }       
    }

    /**
     * Fetch a project from the database based on ID
     * @param id identifier for project to be retrieved
     */
    getProjectById(id) {
        this.service.getProjectById(id).subscribe(
          data => {
              this.displayProject(data)
              if (this.isSubSupplier(data.supplierType) || this.isHeadSupplier(data.supplierType)) {
                  this.getParentByChildId(id)
              }
            },
          error =>  this.showError(error.error),  
          () => this.showLoader = false      
        );          
    }

    isHeadSupplier(supplierType): boolean {
        return supplierType && supplierType === 'headSupplier';
    }

    isSubSupplier(supplierType): boolean {
        return supplierType && supplierType === 'subSupplier';
    }

    getParentByChildId(childId: string) {
        this.service.getParentByChildId(childId).subscribe(
            data => this.parentProject = data,
            error => {
                // Do nothing because having parent is not required.
            }
        )
    }

    getAllRksForSua(suaId) {
        this.service.getAllSuaRegisterControls(suaId).subscribe(
            data => {this.setupRksForSua(data)},
            error => this.showError(error.error)
        )
    }

    setupRksForSua(data) {
        this.suaRks = data;
    }
    /**
     * Show/Hide project details
     */
    showProjectDetails() {
        this.showProjectDetailsVar = !this.showProjectDetailsVar;
    }

    /**
     * Go back to the previous view from where we came
     */
    back() {
        this.appService.setRoute('/project');
    }

    /**
     * Shows or hides contact person details
     */
    toggleContactPersonDetails() {
        this.showContactPersonDetails = !this.showContactPersonDetails;
    }

    /**
     * Shows or hides the control reasons
     */
    toggleControlReason() {
        this.showControlReasonVar = !this.showControlReasonVar;
    }

    /**
     * Show error
     * @param error error text
     */
    showError(error) {
        this.showLoader = false;
        if(error.message == undefined){
            this.confirmService.error(this.appService.getTranslatedErrorMessage(error));
        } else {
            this.confirmService.error(error.message);
        }
    }
    

     /**
     * Display a selected project
     * @param data project returned from backend
     */
    displayProject(data) {
        this.project = data;
        // set the number of notes on first load. this will then be updated when a user adds/removes notes
        this.numOfNotes = this.project.notes.length;
        if (this.project.employer.organisationId === this.customerOrgId) {
            this.isCustomer = true;
        }
        this.setSecClass(this.project.compSecContractLevel);
        this.ready = true;
    }

    /**
     * Sets route destination
     * @param destination destination path
     */
    setRoute(destination) {
        this.appService.setRoute(destination);
    }

    showAttachment() {
        this.ngxSmartModalService.getModal('attachmentModal').open();
    }

   /* ngAfterViewInit() {
        this.ngxSmartModalService.getModal('attachmentModal').onDismiss.subscribe((modal: NgxSmartModalComponent) => {
            // modal is the dismissed modal, so do what you want with it
            this.resetModal();
        });
    }*/

    resetModal() {
        this.newAttachment = false;
        this.showAttBody = false;
        this.uploader.clearQueue();
    }

    showAttachmentBody() {
        this.showAttBody = true;
    }

    selectFile(event) {
        this.selectedFiles = event.target.files;
    }

    showUploader() {
        this.newAttachment = true;
    }

    getFiles(): FileLikeObject[] {
        return this.uploader.queue.map((fileItem) => {
            return fileItem.file;
        });
    }

    upload() {
        let files = this.getFiles();

        for(let i=0; i < files.length; i++) {
            let formData = new FormData();
            formData.append('file', files[i].rawFile, files[i].name);
            this.personViewService.upload(formData).subscribe(event => {
                if(event.status != 200) {
                    return;
                }
                if(event instanceof HttpResponse) {
                    let defaultSuaAttachment = {
                        readableName: files[i].name,
                        uploadedDate: null,
                        attachmentType: "defaultSuaAttachment"
                      }
                      this.personViewService.saveAttachment(defaultSuaAttachment, "default-sua", this.project.id).subscribe(
                          data => this.uploadReady(),
                          error => console.log(error)
                      )
                }
            })
        }
    }

    /**
     * Set's a pdf blob to be previewed upon user request
     * @param data pdf to view as blob
     * @param filename readable name of pdf file
     * @param elementId id of html elemet that triggered the preview
     */
    renderAttachment(data, filename, elementId) {
        this.currentPdfView = elementId;
        this.pdfName = filename;
        this.pdfBlob = new File([(data)], filename, {type: 'application/pdf'});
        if(this.pdfAttachmentViewer != undefined && this.pdfAttachmentViewer != null) {
        this.pdfAttachmentViewer.pdfSrc = this.pdfBlob;
        this.pdfAttachmentViewer.refresh();
        }
        this.showContentForAttachment = true;
    }

    /**
     * Closes the latest pdf preview 
     */
    clearPreview() {
        this.currentPdfView = '';
        this.pdfBlob=null;
        this.pdfName=null;
        this.attachmentContent = null;
        this.showContentForAttachment = false;    
    }

    sanitizeUrl(url) {
        this.attachmentContent = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.showContentForAttachment = true;
    }

    showAttachedFile(id, filename, elementId) {
        this.personViewService.showAttachedFile(id).subscribe(
            data => this.renderAttachment(data, filename, elementId),
            error => console.log(error)
        );
    }

    uploadReady() {
        this.getProjectById(this.id);
        this.uploader.clearQueue();
        this.newAttachment = false;
    }

    /**
    * Archives a defined project
    * @param suaId Identifier for SUA
    */
    async archiveProject(suaId) {
        // Setup entity
        let entityObject = this.archiveModal.createEntityObject(this.entityType.PROJECT, suaId,[]);

        
        // Setup object (SUA in this case)
        let suaObject = this.archiveModal.setupSuaSubSupplierData();

        // Get the list with all affected sub suppliers
        let affectedProjects;
        try {
            affectedProjects = await this.service.getChildrenByProjectId(suaId).toPromise();
        } catch (error) {
            this.showErrorModal(this.errorModalComponent.getErrorModalArray(), error);
            return;
        }

        // Setup data objects specific for entity, in this case for SUA
        for(let i=0; i < affectedProjects.length; i++) {
            let childProject = affectedProjects[i];
            let placeholder;
            // Conversion required as we dont have a readable name for the type
            if(!childProject.archived) {
                if(childProject.compSecContractLevel === 'levelThree') {
                    placeholder = this.i18.sua.form.suaLevel3Label;
                } else if(childProject.compSecContractLevel === 'levelTwo') {
                    placeholder = this.i18.sua.form.suaLevel2Label;
                } else if(childProject.compSecContractLevel === 'levelOne') {
                    placeholder = this.i18.sua.form.suaLevel1Label;
                } else {
                    placeholder = this.i18.sua.form.suaLevelUndefinedLabel;
                }
                // Push each projects information as data object
                suaObject.objectArray.push(this.archiveModal.createModalObject(placeholder,childProject.compIndustry,childProject.compProjectName));
            }
        }
        // Push our SUA object to the entity as we are done constructing it
        // Make sure we got SUA's that are supposed to be archived before we push it
        if(suaObject.objectArray.length > 0) {
            entityObject.dataArray.push(suaObject);
        }


        // Setup another object (RK in this case)
        let rkObject = this.archiveModal.setupDefaultRkData();

        for(let n = 0; n < this.suaRks.length; n++) {
            let rk = this.suaRks[n];
            // Push each rk information as data object
            rkObject.objectArray.push(this.archiveModal.createModalObject(rk.rkRegNumber,rk.status,rk.purposeOfControl));
        }
        // Push our RK object to the entity as we are done constructing it
        if(rkObject.objectArray.length > 0) {
            entityObject.dataArray.push(rkObject);
        }


        // Finalize entity and prepare to show modal
        this.archiveModal.setEntityData(entityObject);

        // Display modal
        this.archiveModal.pop()
    }
        
    /**
    * Set tab view for address or contact person
    * @param type type of address
    */
    setInputWindow(type) {
      this.selectedView=type;
      this.previousType=type;
    }

    /**
     * Delete a attachment
     * @param attachmentId uuid of attachment
     * @param attachmentName name of attachment
     */
    deleteAttachment(attachmentId, attachmentName){
        this.confirmService.confirm(this.i18.sua.form.confirmDeleteOfAttachement + ' ' + attachmentName)
            .then(result => {
                if(result) {
                    this.service.deleteAttachment(attachmentId, this.id)
                        .subscribe(
                            data => this.getProjectById(this.id),
                            error => this.showErrorModal(this.errorModalComponent.getErrorModalArray(), error)
                        )
                }
            });
    }

    /**
     * Show error modal
     * @param modalData modalData array
     * @param error error msg
     */
    showErrorModal(modalData, error) {
        modalData[0] = error.header;
        modalData[1] = error.title;
        modalData[2] = error.message;
        this.errorModalComponent.pop();
    }

    /**
     * unarchive a project
     * @param projectId projectid to restore
     */
    restoreArchivedDefaultProject(projectId){
        this.confirmService.confirm(this.i18.sua.form.confirmUnarchiveProject1 + ' ' + this.project.compProjectName + ' ' +  this.i18.sua.form.confirmRelatedToOrganisation + ' ' + this.project.employer.name + "?")
        .then(result => {
            if(result) {
                this.service.restoreArchivedDefaultProject(projectId)
                    .subscribe(
                        data => this.displayProject(data),
                        error => this.showError(error)
                    )
            }
        });
    }

    /**
     * Helper to set contract security class variable used to show localoffices options.
     * @param inputClass contract security level
     */
     setSecClass(inputClass) {
        if(inputClass === 'levelOne'){
            this.selectedSecClass = 1
        } else if(inputClass === 'levelTwo'){
            this.selectedSecClass = 2
        } else if(inputClass === 'levelThree'){
            this.selectedSecClass = 3
        } else {
            this.selectedSecClass = inputClass;
        }
    }

    /**
     * Anchor
     * @param target id
     */
     public anchor(target): void {
        this.appService.scrollToTarget(target);
    }

    /**
     * pop the hierarchy modal and populate it.
     */
    public async viewHierarchy(){
        this.projectTreeModal.pop()
    }

    /**
     * Helper to update the number of notes displayed on top of the page.
     * Checks if the value from the notes component is a number and updates it.
     * If the value is not a number the amount of notes is taken from the notes array received in the initial request.
     * @param numOfNotes 
     */
     setNumOfNotes(numOfNotes: number){
        if(numOfNotes != null && !Number.isNaN(numOfNotes)){
            this.numOfNotes = numOfNotes;
        } else {
            this.numOfNotes = this.project.notes.length;
        }
    }
}
